import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-count-up' })
export class CountUpComponent {
	constructor(public element: HTMLElement) {
        var countedUp = false;
        var datasetnr = element.dataset.number;

        function isFloat(val: string | undefined) {
            var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
            if (!floatRegex.test(val ?? ""))
                return false;
        
            var intVal = parseFloat(val ?? "");
            if (Number.isNaN(intVal))
                return false;
            return true;
        }
        
        function isInt(val: string | undefined) {
            var intRegex = /^-?\d+$/;
            if (!intRegex.test(val ?? ""))
                return false;
        
            var intVal = parseInt(val ?? "", 10);
            return parseFloat(val ?? "") == intVal && !isNaN(intVal);
        }

        if(!isFloat(datasetnr) && !isInt(datasetnr)) return;

        var number = eval(datasetnr?.split(",").join(".") ?? "0");

        document.addEventListener('scroll', () => {
            countUpIfInViewport();
        });
        window.addEventListener('load', () => {
            countUpIfInViewport();
        });

        function countUpIfInViewport() {
            if(countedUp) return;
            var rect = element.getBoundingClientRect();
            if (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            ) {
                countedUp = true;

                var ticks = 60; // the more, the smoother - Number of repetitions in loop
                var doneTicks = 0;
                var time = 1000 // ms from beginning to end

                var currentNum = 0;
                var decimalPlaces = number.toString().split(".")[1]?.length ?? 0;

                countUp();

                function countUp() {
                    doneTicks++;
                    currentNum = number / ticks + currentNum;
                    element.innerHTML = parseFloat((currentNum).toFixed(decimalPlaces)).toString().split(".").join(",");

                    setTimeout(() => {
                        if(doneTicks >= ticks) return;
                        countUp();
                    }, time / ticks);
                }
            }
        }
	};
}